<template>
  <div class="customer-support-details" :style="appStyleProps">
    <div class="customer-support-text">Customer support</div>
    <a class="customer-support-anchor small"
       :class="{'customized-affiliate': !!affiliateCustomizations}"
       :href="phoneHref">
      {{ phoneDisplay }}
    </a>
    <client-only>
      <div v-if="hours" class="customer-support-text small">{{ hours }}</div>
    </client-only>
    <a class="customer-support-anchor small"
       :class="{'customized-affiliate': !!affiliateCustomizations}"
       :href="emailHref">
      {{ email }}
    </a>
  </div>
</template>

<script>
import env from '~/libs/env'
import { parseISO } from 'date-fns'
import { utcToZonedTime, format } from 'date-fns-tz'
import { phone } from '~/libs/format'
import { mapState } from 'pinia'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'

export default {
  name: 'EmbeddedSupportInfo',
  data() {
    return {
      timeZone: '', // Used to get Clients current timezome
      mdtVsMst: '' // Used to determine currently Mountain Daylight Time (MDT) VS Mountain Standard Time (MST)
    }
  },
  mounted() {
    this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'America/Denver'
    const date = new Date()
    const zonedDate = utcToZonedTime(date, 'America/Denver')
    this.mdtVsMst = format(zonedDate, 'z', { timeZone: 'America/Denver' })
  },
  computed: {
    ...mapState(useAffiliateCustomizationStore, [
      'appStyleProps',
      'affiliateCustomizations',
      'contactInfoPhone',
      'contactInfoEmail',
      'contactInfoHours',
    ]),
    phone() {
      return this.contactInfoPhone ?? env('embeddedSupportPhone')
    },
    email() {
      return this.contactInfoEmail ?? env('embeddedSupportEmail')
    },
    phoneHref() {
      return `tel:+${this.phone}`
    },
    phoneDisplay() {
      return phone(this.phone)
    },
    emailHref() {
      return `mailto:${this.email}`
    },
    hours() {
      if (typeof this.contactInfoHours === 'string') {
        return this.contactInfoHours
      }

      // lendio default hours
      const today = new Date().toLocaleDateString()
      const start = format(
        parseISO(
          (new Date(Date.parse(`${today} 8:00 AM ${this.mdtVsMst}`))).toISOString()
        ), 'h:mm a z', { timeZone: this.timeZone }
      )
      const end = format(
        parseISO(
          (new Date(Date.parse(`${today} 5:00 PM ${this.mdtVsMst}`))).toISOString()
        ),
        'h:mm a zzz',
        { timeZone: this.timeZone }
      )
      return `M-F ${start} - ${end}`.replace(/:00 /g, '')
    },
  },
  watch: {
  },
  methods: {
  },
}
</script>

<style scoped lang="scss">
@import 'assets/styles/affiliate-customizations/affiliate-customization-mixins';
$app-nav-text-primary: var(--app-nav-text-primary);

.customer-support-details {
  padding: 28px;

  .customer-support-text {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: $app-nav-text-primary;
  }

  .customer-support-anchor {
    &.customized-affiliate {
      @include affiliateAppAnchorTag();
    }
  }

  .customer-support-text,
  .customer-support-anchor {
    &.small {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
    }
  }
}
</style>
